import React, { useEffect, useState } from "react";
import { Badge, Button, ConfigProvider, Flex, Modal, Popover, Radio, Select, Table, Tabs, Tooltip, } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined, ClockCircleOutlined, DollarOutlined, ExportOutlined, FieldTimeOutlined, HistoryOutlined, InfoCircleOutlined, MailOutlined, NumberOutlined, PlusCircleOutlined, RobotOutlined, SendOutlined } from '@ant-design/icons';
import dayjs from "dayjs";
import { getCountryCode, openNewTab } from "../../misc_functions";
import { API_DOMAIN, country_codes } from "../../constants";
import wati_logo_only from '../../../assets/wati_logo_only.png'
import axios from "axios";
import { DatePicker } from 'antd';
import utc from "dayjs/plugin/utc";
import { useCommonApiCall } from "../../Api/commonApiCall";
const { RangePicker } = DatePicker;

const SendRemindertoWati = ({ useSnackbar, watiBulkMessageCombo, handleWatiBulkMessageComboClose, selectedRowKeys, onFollowupChange, followupChoice, send_wati_bulk_messages, sendLoadingWatiBulk, rowSelection, formatDuration, get_price_given_time, copyToClipboardModern, carLogoTypes, _simple, followup_id, onFollowupIdChange }) => {
    dayjs.extend(utc);

    const { SuccessSnackbar, ErrorSnackbar, InfoSnackbar, WarningSnackbar, ToastContainer } = useSnackbar();
    const { CommonApiCall } = useCommonApiCall()

    const columns_wati_bulk_message_table = [
        {
            key: "query_id",
            render: (record) => (
                <div>
                    <div>
                        {JSON.parse(record?.moredetails?.wati_reminder_history || '[]')?.length > 0 ?
                            (<div>

                                <Popover content={(<div className="border rounded m-2 p-2">
                                    {JSON.parse(record?.moredetails?.wati_reminder_history || '[]')?.map((e, index) => (
                                        <div key={index}>{index + 1}.&nbsp;Sent on <span style={{ fontWeight: "600" }}>{dayjs(e?.time || null).format("DD-MM-YYYY hh:mm:ss A")}</span>&nbsp;By <span style={{ fontWeight: "600" }}>{e?.admin || "Unknown"}</span></div>
                                    ))}
                                </div>)} title="Reminder message history">
                                    <Badge status="success" style={{ backgroundColor: "green" }} size='small' count={JSON.parse(record?.moredetails?.wati_reminder_history || '[]')?.length}><NumberOutlined style={{ color: "green" }} /></Badge>  {record.query_id}
                                </Popover>
                            </div>) :
                            (<div><NumberOutlined style={{ color: "red" }} /> {record.query_id}</div>)}

                    </div>
                    <div>
                        <HistoryOutlined /> {formatDuration(dayjs(get_price_given_time(record)), dayjs(new Date()))}&nbsp;ago
                    </div>
                    {record.timeline && record.timeline.length > 0 && record.timeline[0].query_created
                        ? (
                            <div>
                                <div className="gap-2 italic" style={{ fontSize: "10px" }}>
                                    <div><DollarOutlined />{dayjs(get_price_given_time(record)).format("DD-MM-YY hh:mm A")}</div>
                                </div>
                                <div className="gap-2 italic" style={{ fontSize: "10px" }}>
                                    <div><PlusCircleOutlined />{dayjs(record.timeline[0].query_created).format("DD-MM-YY hh:mm A")}</div>
                                </div>
                            </div>
                        )
                        : "Timeline data not available"}
                </div>
            ),
            title: "Query Info",
            width: "11%",
            sorter: (a, b) => JSON.parse(a?.moredetails?.wati_reminder_history || '[]')?.length - JSON.parse(b?.moredetails?.wati_reminder_history || '[]')?.length,
            sortDirections: ["descend", "ascend"],
        },
        {
            key: "user_id",
            title: "User",
            dataIndex: "user_id",
            sorter: (a, b) => a.user_id.localeCompare(b.user_id),
            sortDirections: ["descend", "ascend"],
        },
        {
            key: "best_price_received",
            title: "BP",
            dataIndex: "best_price_received",
            sorter: (a, b) => a.best_price_received - b.best_price_received,
            sortDirections: ["descend", "ascend"],
        },
        {
            key: "price_given",
            title: "SP",
            dataIndex: "price_given",
            sorter: (a, b) => a.price_given - b.price_given,
            sortDirections: ["descend", "ascend"],
        },
        {
            key: "body_part",
            title: "Parts",
            render: (record) => (
                <div>
                    <div style={{ maxHeight: "50px", overflowY: "auto", scrollSnapType: "y mandatory", scrollBehavior: "smooth" }}>
                        {record.body_part.split(",").map((item, index) => (<div style={{ scrollSnapAlign: "start" }}>{index + 1}.&nbsp;{item}</div>))}
                    </div>
                    {record.body_part.split(",").length > 1 ? (<div style={{ fontSize: "11px", color: "#777" }} className="flex justify-end pr-1"><Tooltip title="Scroll inside the parts-list to see all the names.">Total :&nbsp;{record.body_part.split(",").length}</Tooltip></div>) : null}
                </div>
            ),
        },
        {
            key: "make_model_additional_info",
            title: "Make - Model",
            render: (record) => (
                <div>
                    <div className="flex drop-shadow">
                        <div style={{ width: "50px" }}>
                            {carLogoTypes[record.make.toLowerCase().replaceAll(" ", "-")] ?
                                (<Tooltip title={record.make}>
                                    <img style={{ width: "100%" }} src={carLogoTypes[record.make.toLowerCase().replaceAll(" ", "-")]?.logotype?.uri ? carLogoTypes[record.make.toLowerCase().replaceAll(" ", "-")].logotype.uri : alert(record.make)} />
                                </Tooltip>) : record.make}
                        </div>

                        <div style={{ width: "100%" }}>
                            <div className="border rounded p-0.5 flex" style={{ backgroundColor: "#9aede9", color: "#295754", width: "100%", overflowX: "auto", whiteSpace: "nowrap", maxWidth: "100%", minWidth: "70px" }}>
                                <div style={{ fontWeight: "600", color: "Black" }}>{record.model.trim()}&nbsp;</div>
                                {record.year ? (<div>({record.year.trim()})&nbsp;</div>) : ""}
                                {record.cylinder ? (<div>({record.cylinder.trim()} Cylinders)&nbsp;</div>) : ""}
                                {record.region ? (<div>({record.region.trim()})&nbsp;</div>) : ""}
                            </div>
                        </div>
                    </div>
                </div >
            ),
        },
        {
            key: "cus_name",
            title: "Customer",
            render: (record) => (
                <div>
                    {record.moredetails?.queryOrigin?.length > 0 ? (<div style={{ fontSize: "11px", color: "#777" }} className="flex justify-end pr-1">

                        <div>{record.moredetails?.queryOrigin[0]?.label}</div>
                    </div>) : ""}
                    < div className="border rounded p-1" style={{ fontWeight: "550", overflowX: "auto", whiteSpace: "nowrap", maxWidth: "180px", minWidth: "90px" }}>
                        {record?.cus_name ? record?.cus_name : <i>Name Unknown</i>}
                    </div >
                    <div className="border rounded p-1 mt-0.5 flex justify-between" style={{ maxWidth: "180px", minWidth: "90px" }}>
                        <div className="flex" style={{ overflowX: "auto" }}>
                            <Tooltip title={country_codes[getCountryCode(record?.phone)] || "Unknown"}>
                                <img style={{ width: "15px" }} src={"https://cdn.clare.ai/flags/" + getCountryCode(record?.phone) + ".svg"} alt="Unknown" />
                            </Tooltip>
                            &nbsp;
                            <div>{record?.phone ? (<div className="cursor-pointer" onClick={() => copyToClipboardModern(record.phone, "Number")}><Tooltip title="Click here to copy the number to clipboard.">{record?.phone}</Tooltip></div>) : <i>Number Unknown</i>}</div>
                        </div>
                        <div className="flex items-center justify-center cursor-pointer">
                            <Tooltip title="Go to the WATI chat">
                                <img id={`wati_chat_button_${record?.query_id}`} onClick={() => _simple(`wati_chat_button_${record?.query_id}`, record?.phone)} style={{ width: "15px" }} src={wati_logo_only} />
                            </Tooltip>
                        </div>
                    </div>
                </div >
            ),
            sorter: (a, b) => a?.moredetails?.queryOrigin[0]?.label.localeCompare(b?.moredetails?.queryOrigin[0]?.label),
            sortDirections: ["descend", "ascend"],
        }
    ]
    const [bot_or_message_select_values, set_bot_or_message_select_values] = useState(null)

    const [select_loading, set_select_loading] = useState(true)

    const [bot_flows, set_bot_flows] = useState(null)
    const [quick_replies, set_quick_replies] = useState(null)

    const get_bot_flows = async () => {
        set_select_loading(true);
        try {
            var res = await axios.get(API_DOMAIN + "/whatsapp/get_bot_flows")
            if (res.data.success) {
                var temp = res?.data?.data?.map(e => ({
                    value: e.id,
                    label: e.name
                }))
                set_bot_flows(temp)
                set_bot_or_message_select_values(temp)
            }

        } catch (error) {

        }
        finally {
            set_select_loading(false);
        }
    }

    const get_quick_replies = async () => {
        set_select_loading(true);
        try {
            var res = await axios.post(API_DOMAIN + "/whatsapp/get_wati_templates");
            if (res.data.success) {
                set_quick_replies(res?.data?.data?.map(e => ({
                    value: e.id,
                    label: e.name
                })))
            }
        } catch (error) {

        }
        finally {
            set_select_loading(false);
        }
    }

    const [chatStatus, setChatStatus] = useState(null)
    const [filterDateTime, setFilterDateTime] = useState(null)
    const [watiChats, setWatiChats] = useState(null)
    const [fetchChatsLoading, setFetchChatsLoading] = useState(false)
    const [manageChatRowSelection, setManageChatRowSelection] = useState(null)
    const onManageChatSelectChange = newSelectedRowKeys => {
        setManageChatRowSelection(newSelectedRowKeys);
    };
    const rowSelectionManageChat = {
        manageChatRowSelection,
        onChange: onManageChatSelectChange,
    };

    const get_wati_chats_with_status = async () => {
        if (!chatStatus) {
            WarningSnackbar(`Please select the Chat Status`)
            return;
        }
        if (!filterDateTime?.[0]) {
            WarningSnackbar(`Please set the 'From' date/time`)
            return;
        }
        if (!filterDateTime?.[1]) {
            WarningSnackbar(`Please set the 'To' date/time`)
            return;
        }
        setFetchChatsLoading(true);
        const response = await CommonApiCall({
            status: chatStatus,
            from: new Date(filterDateTime?.[0] + (4 * 60 * 60 * 1000)),
            to: new Date(filterDateTime?.[1] + (4 * 60 * 60 * 1000))
        }, "wati_apis/get_wati_chats_by_status", "post");
        if (response.status) {
            SuccessSnackbar(`Retrieved chats`)
            console.log(`response.data = ${JSON.stringify(response.data)}`);
            setWatiChats(sortByRemainingTime(response.data, 0))
        }
        setFetchChatsLoading(false);
    }

    const [manageChatsReplyTemplates, setManageChatsReplyTemplates] = useState(null)
    const [selectedManageChatsReplyTemplate, setSelectedManageChatsReplyTemplate] = useState(null)
    const get_manage_chat_replies = async () => {
        const response = await CommonApiCall({ mode: "wati_manage_chat_templates" },
            "whatsapp/get_misc_mode", "post");
        if (response.status) {
            setManageChatsReplyTemplates(response.data)
        }
    }

    useEffect(() => {
        get_bot_flows();
        get_manage_chat_replies();
        get_quick_replies();
        set_bot_or_message_select_values(bot_flows);
        setChatStatus(null);
        setFilterDateTime(null);
        setWatiChats(null)
        setManageChatRowSelection(null)
    }, []);

    useEffect(() => {
        onFollowupIdChange(null);
        if (followupChoice == 'bot')
            set_bot_or_message_select_values(bot_flows)
        else if (followupChoice == 'message')
            set_bot_or_message_select_values(quick_replies)
    }, [followupChoice]);

    function sortByRemainingTime(arr, order = 0) {
        // order: 0 = ascending, 1 = descending
        const parseTime = (t) => {
            if (!t || !t.includes(":")) return Infinity; // handle nulls or invalids
            const [h, m] = t.split(":").map(Number);
            return h * 60 + m;
        };

        return arr.sort((a, b) => {
            const aTotal = parseTime(a?.remainingTime);
            const bTotal = parseTime(b?.remainingTime);

            return order === 1 ? bTotal - aTotal : aTotal - bTotal;
        });
    }

    const open_wati_chat_simple = async (conversationId) => {
        const wati_url = `https://live.wati.io/5068/teamInbox/${conversationId}?filter={%22filterType%22:0,%22channelType%22:0,%22filterChannelIds%22:[%22%22]}`
        openNewTab(wati_url);
    }

    const getTimeDifference = (from, to) => {
        if (!from || !to) return "0min";

        const start = new Date(from).getTime();
        const end = new Date(to).getTime();

        if (isNaN(start) || isNaN(end)) return "0min";

        // difference (can be negative)
        const diffMs = end - start;
        const diffMinutesTotal = Math.floor(Math.abs(diffMs) / (1000 * 60));

        const hours = Math.floor(diffMinutesTotal / 60);
        const minutes = diffMinutesTotal % 60;

        const sign = diffMs < 0 ? "-" : ""; // prefix for negative

        if (hours && minutes) return `${sign}${hours}hrs ${minutes}min`;
        if (hours) return `${sign}${hours}hrs`;
        return `${sign}${minutes}min`;
    }

    const [sendChatsLoading, setSendChatsLoading] = useState(false);

    const send_message_manage_chat = async () => {
        if (manageChatRowSelection && manageChatRowSelection.length > 0 && selectedManageChatsReplyTemplate) {
            setSendChatsLoading(true)
            const final_chatset = watiChats.filter(e =>
                manageChatRowSelection.includes(e.conversationId)
            );

            const response = await CommonApiCall({ chat_ids: final_chatset, template_id: selectedManageChatsReplyTemplate }, "wati_apis/send_wati_bulk_reminder_chat_id", 'post');
            console.log(response);
            if (response.status == true) {
                SuccessSnackbar("Sent messages to all successfully");
            }
            setSendChatsLoading(false)
        }
        else {
            WarningSnackbar(`make sure the chats and reply are selected`);
            return;
        }
    }

    const columns_wati_chats_table = [
        {
            key: "remainingTime",
            title: "Chat Expiry",
            render: (value) => (
                <div
                    className="gap-2 flex"
                    style={{
                        color: `${parseInt(value?.remainingTime?.substring(0, 2)) <= 4 ? "red" : "unset"}`,
                    }}
                >
                    <div>
                        <ClockCircleOutlined />
                    </div>
                    <div>
                        {value?.remainingTime}
                    </div>
                </div>
            ),
            sorter: (a, b) => {
                const toMinutes = (timeStr) => {
                    if (!timeStr) return 0;
                    const [hours, minutes] = timeStr.split(":").map(Number);
                    return hours * 60 + minutes;
                };

                const timeA = toMinutes(a?.remainingTime);
                const timeB = toMinutes(b?.remainingTime);

                return timeA - timeB;
            },
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: "Customer",
            render: (value) => (
                <div>
                    <div className="flex justify-center">
                        <b>
                            {value?.name}
                        </b>
                    </div>
                    <div className="flex items-center justify-between gap-1 border rounded p-1">
                        <div className="flex" style={{ overflowX: "auto" }}>
                            <Tooltip title={country_codes[getCountryCode(value?.number)] || "Unknown"}>
                                <img style={{ width: "15px" }} src={"https://cdn.clare.ai/flags/" + getCountryCode(value?.number) + ".svg"} alt="Unknown" />
                            </Tooltip>
                            &nbsp;
                            <div>{value?.number ? (<div className="cursor-pointer" onClick={() => copyToClipboardModern(value?.number, "Number")}><Tooltip title="Click here to copy the number to clipboard.">{value?.number}</Tooltip></div>) : <i>Number Unknown</i>}</div>
                        </div>
                        <div className="cursor-pointer">
                            <Tooltip title="Go to the WATI chat">
                                <img id={`wati_chat_button_${value?.contactId}`} onClick={() => open_wati_chat_simple(value?.conversationId)} style={{ width: "15px" }} src={wati_logo_only} />
                            </Tooltip>
                        </div>
                    </div>
                </div>
            ),
            width: "8%"
        },
        {
            title: "Sent time",
            render: (value) => (
                <div className="gap-2 flex">
                    <ArrowUpOutlined style={{ color: "green" }} />{dayjs(value?.lastMessageDate).format("YYYY-MM-DD hh:mm A")}
                </div>
            ),
        },
        {
            title: "Received time",
            render: (value) => (
                <div className="gap-2 flex">
                    <ArrowDownOutlined style={{ color: "green" }} />{dayjs(value?.lastIncomingDate).format("YYYY-MM-DD hh:mm A")}
                </div>
            ),
        },
        {
            title: `Reply Gap`,
            render: (value) => (
                <div className="justify-between flex">
                    <div className="gap-2 flex">
                        <div>
                            <FieldTimeOutlined />
                        </div>
                        <div>
                            {getTimeDifference(value?.lastIncomingDate, value?.lastMessageDate)}
                        </div>
                    </div>
                    {getTimeDifference(value?.lastIncomingDate, value?.lastMessageDate).includes("-") ? (
                        <div>
                            <Tooltip title={`If the time difference is negative, agent did not reply for this time after the last message of the customer.`}>
                                <InfoCircleOutlined />
                            </Tooltip>
                        </div>
                    ) : null}
                </div>
            ),
            width: "12%",
            sorter: (a, b) => {
                const toMinutes = (str) => {
                    if (!str) return 0;
                    const hrMatch = str.match(/(\d+)\s*hr|hrs/i);
                    const minMatch = str.match(/(\d+)\s*min/i);
                    const hours = hrMatch ? parseInt(hrMatch[1]) : 0;
                    const minutes = minMatch ? parseInt(minMatch[1]) : 0;
                    return hours * 60 + minutes;
                };

                const diffA = toMinutes(getTimeDifference(a?.lastIncomingDate, a?.lastMessageDate));
                const diffB = toMinutes(getTimeDifference(b?.lastIncomingDate, b?.lastMessageDate));
                return diffA - diffB;
            },
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: `Since Reply`,
            render: (value) => (
                <div className="gap-2 flex">
                    <div>
                        <FieldTimeOutlined />
                    </div>
                    <div>
                        {getTimeDifference(value?.lastMessageDate, new Date())}
                    </div>
                </div>
            ),
            width: "11%",
            sorter: (a, b) => {
                const toMinutes = (str) => {
                    if (!str) return 0;
                    const hrMatch = str.match(/(\d+)\s*hr|hrs/i);
                    const minMatch = str.match(/(\d+)\s*min/i);
                    const hours = hrMatch ? parseInt(hrMatch[1]) : 0;
                    const minutes = minMatch ? parseInt(minMatch[1]) : 0;
                    return hours * 60 + minutes;
                };

                const diffA = toMinutes(getTimeDifference(a?.lastMessageDate, new Date()));
                const diffB = toMinutes(getTimeDifference(b?.lastMessageDate, new Date()));
                return diffA - diffB;
            },
            sortDirections: ['ascend', 'descend'],
        },
        {
            key: "lastAssignedTo",
            title: "Agent",
            dataIndex: "lastAssignedTo",
            sorter: (a, b) => {
                const nameA = a.lastAssignedTo?.toLowerCase() || "";
                const nameB = b.lastAssignedTo?.toLowerCase() || "";
                return nameA.localeCompare(nameB);
            },
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: "Last message",
            render: (value) => (
                <div>
                    <div className="flex justify-end">
                        <Tooltip title="Click to open the chat in SRM">
                            <ExportOutlined className="cursor-pointer hover:scale-110 transition-transform" />
                        </Tooltip>
                    </div>
                    <div style={{ maxHeight: "80px", overflowY: "auto", scrollSnapType: "y mandatory", scrollBehavior: "smooth" }}>
                        {value?.lastMesage}
                    </div>
                </div>
            ),
            width: "10%"
        }
    ]

    const items = [
        {
            key: '1',
            label: 'Send Reminder to registered enquiry chats (legacy feature)',
            children: (
                <div>
                    <div className="flex justify-between ml-2 mr-2 mb-0 p-2 items-center">

                        <div>
                            <span style={{ fontWeight: "600" }}>{selectedRowKeys.length}</span> Row{selectedRowKeys.length > 1 ? `s` : null} selected
                        </div>

                        <div>
                            <div>
                                There are total <span style={{ fontWeight: "600" }}>{watiBulkMessageCombo?.data?.length}</span> Queries waiting for confirmation.
                            </div>
                            <div className="flex justify-center">
                                Make your selection and click send
                            </div>
                        </div>

                        <div className="flex justify-between">

                            <div className="p-2 border rounded mr-2">
                                <div className="flex justify-center">
                                    <Radio.Group
                                        onChange={onFollowupChange}
                                        value={followupChoice}
                                        options={[
                                            {
                                                value: 'bot',
                                                label: (
                                                    <Flex gap="small" justify="center" align="center" vertical>
                                                        <RobotOutlined style={{ fontSize: 18 }} />
                                                        Invoke Bot
                                                    </Flex>
                                                ),
                                            },
                                            {
                                                value: 'message',
                                                label: (
                                                    <Flex gap="small" justify="center" align="center" vertical>
                                                        <MailOutlined style={{ fontSize: 18 }} />
                                                        Send Message
                                                    </Flex>
                                                ),
                                            }
                                        ]}
                                    />
                                </div>
                                <Select
                                    optionFilterProp="label"
                                    loading={select_loading}
                                    style={{ width: 150 }}
                                    allowClear
                                    onChange={onFollowupIdChange}
                                    showSearch
                                    options={bot_or_message_select_values}
                                    value={followup_id}
                                />
                            </div>

                            <div className="flex items-center">
                                <ConfigProvider
                                    theme={{
                                        components: {
                                            Button: {
                                                defaultHoverColor: "#ffffff",
                                                defaultHoverBg: "#3be368",
                                                defaultBg: "#31bd56",
                                            },
                                        },
                                    }}
                                >
                                    <Tooltip title={`${selectedRowKeys?.length == 0 ? 'Select at least one query to send reminder message' : 'Click to send reminder message to selected customers on WATI'}`}>
                                        <Button
                                            variant="contained"
                                            onClick={() => send_wati_bulk_messages()}
                                            loading={sendLoadingWatiBulk}
                                            disabled={selectedRowKeys?.length == 0 ? true : false}
                                        >
                                            Send <SendOutlined />
                                        </Button>
                                    </Tooltip>
                                </ConfigProvider>
                            </div>

                        </div>

                    </div>
                    <div className="border rounded" style={{ height: "65vh", overflowY: "auto" }}>
                        <Table
                            rowSelection={rowSelection}
                            rowKey={(record) => record.query_id}
                            dataSource={watiBulkMessageCombo?.data}
                            className="border rounded"
                            style={{ width: "100%", minWidth: "70%", overflowX: "auto", backgroundColor: "unset !important" }}
                            columns={columns_wati_bulk_message_table}
                            // loading={loading_wati_approval_table}
                            bordered={true}
                            pagination={false}
                        />
                    </div>
                </div>
            ),
        },
        {
            key: '2',
            label: 'Manage chats',
            children: (
                <div>
                    <div className="flex justify-between gap-2">
                        <Select
                            allowClear
                            optionFilterProp="label"
                            placeholder="Select Chat Type"
                            value={chatStatus}
                            onChange={(e) => {
                                setChatStatus(e)
                            }}
                            options={[
                                { label: "Open", value: 1 },
                                { label: "Solved", value: 2 },
                                { label: "Pending", value: 3 },
                                { label: "Expired", value: 4 },
                            ]}
                        />
                        <RangePicker
                            style={{ width: "560px" }}
                            showTime={{ format: 'hh:mm A' }}
                            format="YYYY-MM-DD hh:mm A"
                            value={filterDateTime}
                            onChange={(value, dateString) => {
                                setFilterDateTime(value)
                            }}
                        />
                        <ConfigProvider
                            theme={{
                                components: {
                                    Button: {
                                        defaultHoverColor: "#ffffff",
                                        defaultColor: "#ffffff",
                                        defaultHoverBg: "#3be368",
                                        defaultBg: "#31bd56",
                                    },
                                },
                            }}
                        >
                            <Button
                                onClick={() => get_wati_chats_with_status()}
                                loading={fetchChatsLoading}
                            >Fetch Chats
                            </Button>

                        </ConfigProvider>
                    </div>
                    <div className="border rounded mt-1" style={{ height: "50vh", overflowY: "auto" }}>
                        <Table
                            rowSelection={rowSelectionManageChat}
                            rowKey={(record) => record.conversationId}
                            dataSource={watiChats}
                            loading={fetchChatsLoading}
                            className="border rounded"
                            style={{ width: "100%", minWidth: "70%", overflowX: "auto", backgroundColor: "unset !important" }}
                            columns={columns_wati_chats_table}
                            // loading={loading_wati_approval_table}
                            bordered={true}
                            pagination={false}
                        />
                    </div>
                    <div className="border rounded mt-1.5 p-2 flex justify-between" style={{ width: "100%" }}>
                        <div className="flex">
                            <b>{manageChatRowSelection?.length || 0}</b>&nbsp;Row{manageChatRowSelection?.length > 1 ? 's' : null}&nbsp;selected
                        </div>
                        <div className="flex">
                            There are&nbsp;<b>{watiChats?.length || 0}</b>&nbsp;rows
                        </div>

                        <div className="flex gap-1" style={{ width: "450px" }}>
                            <Select
                                style={{ width: "100%" }}
                                allowClear
                                showSearch
                                optionFilterProp="label"
                                value={selectedManageChatsReplyTemplate}
                                onChange={setSelectedManageChatsReplyTemplate}
                            >
                                {manageChatsReplyTemplates?.map((e) => (
                                    <Select.Option key={e.id} value={e.id} label={e.name}>
                                        <Tooltip title={e.message} placement="right">
                                            <span>{e.name}</span>
                                        </Tooltip>
                                    </Select.Option>
                                ))}
                            </Select>
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Button: {
                                            defaultHoverColor: "#ffffff",
                                            defaultColor: "#ffffff",
                                            defaultHoverBg: "#3be368",
                                            defaultBg: "#31bd56",
                                        },
                                    },
                                }}
                            >
                                <Button
                                    onClick={() => send_message_manage_chat()}
                                    loading={sendChatsLoading}
                                >Send <SendOutlined />
                                </Button>

                            </ConfigProvider>
                        </div>
                    </div>
                </div>
            ),
        },
    ]


    return (
        <>
            < Modal
                open={watiBulkMessageCombo?.open}
                onCancel={handleWatiBulkMessageComboClose}
                centered
                maskClosable={false}
                title={`Send Bulk Reminder Message to All Pending Customers`}
                width={1370}
                footer={
                    <div className="flex justify-center italic" style={{ fontSize: "12px", color: "gray" }}>
                        <span style={{ color: "red" }}>*</span>&nbsp;Every messages are sent using the respective users' WATI token, hence appears to be sent by them in WATI
                    </div >
                }
            >
                <div className="p-2 m-2 rounded border drop-shadow" style={{ backgroundColor: "#f7f7f7" }}>


                    <div>
                        <Tabs defaultActiveKey="1" items={items} />
                    </div>

                </div>
            </Modal >
        </>

    );
}

export default SendRemindertoWati;